import React, { useEffect, useRef, useState } from "react";
import { Button, Grid } from "@mui/material";
import Quill from "quill";
import "quill/dist/quill.snow.css";
import SoftBox from "components/SoftBox";
import PopUp from "./Component/PopUp";
import { useAppServices } from "hook/services";
import img_empty from "assets/images/img.jpg";
import deleteIcon from "../../../../../assets/themeIcons/delete-icon.svg";
import editIcon from "../../../../../assets/themeIcons/edit-icon.svg";
import toast from "react-hot-toast";
import { useAgencyInfo } from "context/agency";
import GhlMediaGallery from "components/GhlMediaGallery";
import { FaImages } from "react-icons/fa";
import SoftTypography from "components/SoftTypography";
import PrimaryButton from "../../../components/PrimaryButton";
import "./accountDetailTabs.css";

function NewsFeed({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [popup, setPopup] = useState(false);
  const [selectedNewsFeed, setSelectedNewsFeed] = useState(null);
  const [loading, setLoading] = useState(false);
  const [newsFeedsData, setNewsFeedsData] = useState([]);
  const [agency] = useAgencyInfo();
  const [MainImage, setMainImage] = useState("");
  const [mainImageId, setmainImageId] = useState("");
  const [bannerImageId, setbannerImageId] = useState("");
  const [bannerImage, setbannerImage] = useState("");
  const [ghlGalleryOpen, setGhlGalleryOpen] = useState(false);
  const [ghlImageType, setGhlImageType] = useState("image");

  const openGhlGallery = (type) => {
    setGhlImageType(type);
    setGhlGalleryOpen(true);
  };

  const handleGhlImageSelect = (pick) => {
    if (!pick?.url) return;
    if (ghlImageType === "image") {
      if (selectedNewsFeed) {
        setSelectedNewsFeed((prev) => ({ ...prev, image: pick?.url, image_id: pick?._id }));
      } else {
        setMainImage(pick?.url);
        setmainImageId(pick?._id);
      }
    } else if (ghlImageType === "banner") {
      if (selectedNewsFeed) {
        setSelectedNewsFeed((prev) => ({ ...prev, banner: pick?.url, banner_id: pick?._id }));
      } else {
        setbannerImage(pick?.url);
        setbannerImageId(pick?._id);
      }
    }
    toast.success("Image selected.");
  };

  const quillRef = useRef(null);
  const quillInstance = useRef(null);

  const getNewsFeeds = async () => {
    const { response } = await AppService.newsFeed.Get({
      query: `account_id=${formData._id}`,
    });
    if (response) {
      setNewsFeedsData(response.data);
    }
  };

  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        if (quillRef.current && !quillInstance.current) {
          quillInstance.current = new Quill(quillRef.current, {
            theme: "snow",
          });
        }
        if (selectedNewsFeed && quillInstance.current) {
          quillInstance.current.root.innerHTML = selectedNewsFeed.description || "";
        }
      }, 100);
    }
    return () => {
      if (!popup && quillInstance.current) {
        quillInstance.current = null;
      }
    };
  }, [popup, selectedNewsFeed]);

  const openPopup = () => setPopup(true);

  const closePopup = () => {
    setPopup(false);
    setSelectedNewsFeed(null);
    quillInstance.current = null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let description = quillInstance.current?.root.innerHTML.trim() || "";
    description = description.replace(/<div>/g, "<p>").replace(/<\/div>/g, "</p>");

    const payload = {
      title: e.target.title.value,
      image: MainImage || selectedNewsFeed?.image,
      image_id: mainImageId || selectedNewsFeed?.image_id,
      banner: bannerImage || selectedNewsFeed?.banner,
      banner_id: bannerImageId || selectedNewsFeed?.banner_id,
      description,
      account_id: formData._id,
      agency_id: formData.agency_id,
    };

    let response;

    if (selectedNewsFeed) {
      response = await AppService.newsFeed.Update({
        payload: { ...payload, _id: selectedNewsFeed._id },
      });
    } else {
      response = await AppService.newsFeed.Create({ payload });
    }

    if (response) {
      handleRefresh();
      setPopup(false);
      setSelectedNewsFeed(null);
      setMainImage("");
      setmainImageId("");
      setbannerImage("");
      setbannerImageId("");
      getNewsFeeds();
      toast.success(
        selectedNewsFeed ? "News Feed updated successfully!" : "New News Feed created successfully!"
      );
    } else {
      toast.error("Error updating Data");
    }

    setLoading(false);
  };

  const deleteNewsFeed = async (newsFeed) => {
    const { response } = await AppService.newsFeed.Delete({
      query: `_id=${newsFeed._id}`,
    });

    if (response) {
      handleRefresh();
      getNewsFeeds();
      toast.success("Delete Successfully");
    } else {
      toast.error("Error deleting attachment");
    }
  };

  const editNewsFeed = (newsFeed) => {
    setSelectedNewsFeed(newsFeed);
    if (quillInstance.current) {
      quillInstance.current.root.innerHTML = newsFeed.description || "";
    }
    openPopup();
  };

  useEffect(() => {
    getNewsFeeds();
  }, [formData]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit(event);
    }
  };

  return (
    <div className="sd-account-detail-tab">
      <p className="text-center">{success}</p>

      <div style={{ display: "flex", justifyContent: "end", margin: "0 10px" }}>
        <PrimaryButton showPlus onClick={openPopup}>
          Add News Feed
        </PrimaryButton>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {newsFeedsData?.map((newsFeed, index) => (
          <SoftBox
            key={index}
            style={{
              margin: "10px",
              width: "30%",
              borderRadius: "10px",
              border: "1px solid #f5f5f5",
              padding: "10px",
            }}
          >
            <img
              src={newsFeed.image || img_empty}
              alt={newsFeed.title}
              style={{
                width: "100%",
                height: "200px",
                objectFit: "cover",
                borderRadius: "8px",
              }}
            />
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px" }}>
              <h4 style={{ margin: 0 }}>{newsFeed.title}</h4>
              <div style={{ display: "flex", gap: "10px" }}>
                <Button
                  variant="contained"
                  color="white"
                  onClick={() => editNewsFeed(newsFeed)}
                  style={{ minWidth: "auto", padding: "8px" }}
                >
                  <img src={editIcon} width={20} style={{ cursor: "pointer" }} alt="Edit" />
                </Button>
                <Button
                  variant="contained"
                  color="white"
                  style={{
                    background: "#e44d36",
                    color: "#fff",
                    minWidth: "auto",
                    padding: "8px",
                  }}
                  onClick={() => deleteNewsFeed(newsFeed)}
                >
                  <img src={deleteIcon} width={20} style={{ cursor: "pointer" }} alt="Delete" />
                </Button>
              </div>
            </div>
          </SoftBox>
        ))}
      </div>

      <PopUp
        open={popup}
        handleClose={closePopup}
        title={selectedNewsFeed ? "Edit News Feed" : "New News Feed"}
      >
        <form onSubmit={handleSubmit} onKeyPress={handleKeyPress}>
          <div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Title</label>
                  <input
                    className="form-control-agust"
                    name="title"
                    type="text"
                    placeholder="Title"
                    defaultValue={selectedNewsFeed?.title || ""}
                    required
                  />
                </SoftBox>
              </div>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Image</label>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                    <button
                      type="button"
                      onClick={() => openGhlGallery("image")}
                      title="Choose from GHL Media"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                      }}
                    >
                      <FaImages size={16} />
                      {(selectedNewsFeed?.image || MainImage) ? "Change Image" : "Select from GHL Media"}
                    </button>
                    {(selectedNewsFeed?.image || MainImage) && (
                      <img
                        src={selectedNewsFeed?.image || MainImage}
                        alt="News feed"
                        style={{
                          width: "72px",
                          height: "72px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                        }}
                      />
                    )}
                  </div>
                </SoftBox>
              </div>
            </div>
            <div style={{ display: "flex", width: "100%" }}>
              <div style={{ width: "50%", padding: "10px" }}>
                <SoftBox>
                  <label className="text-black">Banner Image</label>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px", marginTop: "6px" }}>
                    <button
                      type="button"
                      onClick={() => openGhlGallery("banner")}
                      title="Choose from GHL Media"
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "white",
                        border: "none",
                        padding: "10px 18px",
                        borderRadius: "10px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: 600,
                        whiteSpace: "nowrap",
                        boxShadow: "0 2px 6px rgba(25, 118, 210, 0.35)",
                      }}
                    >
                      <FaImages size={16} />
                      {(selectedNewsFeed?.banner || bannerImage) ? "Change Banner" : "Select from GHL Media"}
                    </button>
                    {(selectedNewsFeed?.banner || bannerImage) && (
                      <img
                        src={selectedNewsFeed?.banner || bannerImage}
                        alt="Banner"
                        style={{
                          width: "120px",
                          height: "48px",
                          objectFit: "cover",
                          borderRadius: "8px",
                          border: "1px solid #e2e8f0",
                        }}
                      />
                    )}
                  </div>
                  <Grid item xs={12} display={"flex"} alignItems="center" style={{ padding: 0 }}>
                    <SoftTypography
                      variant="p"
                      className="roboto-family"
                      style={{ fontSize: "13px", marginTop: "8px", color: "#64748b" }}
                    >
                      1MB maximum size. 5:2 ratio. Recommended dimensions: 1752 x 716 pixels.
                    </SoftTypography>
                  </Grid>
                </SoftBox>
              </div>
            </div>
            <div style={{ padding: "10px" }}>
              <SoftBox>
                <label className="text-black">Description</label>
                <div ref={quillRef} className="sd-account-detail-tab__quill" style={{ height: "250px", marginBottom: "20px" }} />
              </SoftBox>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              margin: "0 10px",
            }}
          >
            <PrimaryButton type="submit" disabled={loading}>
              {loading ? "Processing..." : selectedNewsFeed ? "Update News Feed" : "Save News Feed"}
            </PrimaryButton>
          </div>
        </form>
      </PopUp>

      <GhlMediaGallery
        open={ghlGalleryOpen}
        onClose={() => setGhlGalleryOpen(false)}
        onSelect={handleGhlImageSelect}
        title={`Select ${ghlImageType === "banner" ? "Banner" : "News Feed"} Image`}
        enableCrop
        cropAspectRatio={ghlImageType === "image" ? 1 / 1 : 7 / 2}
      />
    </div>
  );
}

export default NewsFeed;
